<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>เข้าสู่ระบบ</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form ref="form" @submit.prevent="login()">
                  <v-text-field
                    v-model="empCode"
                    name="empCode"
                    label="รหัสพนักงาน"
                    type="text"
                    placeholder="รหัสพนักงาน"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    name="password"
                    label="รหัสผ่าน"
                    type="password"
                    placeholder="รหัสผ่าน"
                    required
                  ></v-text-field>
                  <v-btn
                    type="submit"
                    class="mt-4"
                    color="primary"
                    value="log in"
                  >
                    เข้าสู่ระบบ
                  </v-btn>
                </form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'Login',

  data() {
    return {
      empCode: '',
      password: '',
    }
  },

  mounted() {
    if (this.$store?.getters['auth/token']) {
      this.$router.push({
        name: 'Dashboard',
      })
    }
  },

  methods: {
    login() {
      const { empCode, password } = this
      const payload = {
        emp_code: empCode,
        pass: password,
      }
      this.$store.dispatch('auth/login', payload)
    },
  },
}
</script>
